// Bounded indoor-watercourse adaptation. The reused source stays immutable.
// This is an art-directed flow cue based on geometric grade, not hydraulics.
export function adaptWatercourseSlope(material, { quietGrade, fullGrade }) {
  if (!material?.isShaderMaterial || !Number.isFinite(quietGrade) || !Number.isFinite(fullGrade)
      || quietGrade < 0 || fullGrade <= quietGrade) throw Error('Invalid watercourse slope contract');
  const original = 'slope += river * vec2(sin(flow + p.x * 14.0), cos(flow * .81 + p.y * 11.0)) * .024;';
  if (material.fragmentShader.split(original).length !== 2) throw Error('Reused flow equation changed');
  const adaptation = `// Flat lower pools do not inherit the source cascade current train.
        float localGrade = length(vNormal.xz) / max(abs(vNormal.y), .001);
        float currentCue = smoothstep(${quietGrade.toFixed(6)}, ${fullGrade.toFixed(6)}, localGrade);
        slope += river * currentCue * vec2(sin(flow + p.x * 14.0), cos(flow * .81 + p.y * 11.0)) * .024;`;
  material.fragmentShader = material.fragmentShader.replace(original, adaptation);
  material.name = 'Depth water with grade-local current cue';
  material.needsUpdate = true;
  return { original, adaptation, changedEquationCount: 1 };
}
